import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, trendValue, color = 'primary' }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return {
          bg: 'bg-success/10',
          border: 'border-success/20',
          icon: 'var(--color-success)',
          text: 'text-success'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          border: 'border-warning/20',
          icon: 'var(--color-warning)',
          text: 'text-warning'
        };
      case 'error':
        return {
          bg: 'bg-error/10',
          border: 'border-error/20',
          icon: 'var(--color-error)',
          text: 'text-error'
        };
      default:
        return {
          bg: 'bg-primary/10',
          border: 'border-primary/20',
          icon: 'var(--color-primary)',
          text: 'text-primary'
        };
    }
  };

  const colorClasses = getColorClasses();

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 hover:shadow-elevation-1 transition-all duration-200 shadow-card">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="text-sm font-body font-medium text-muted-foreground mb-1">
            {title}
          </div>
          <div className="text-xl sm:text-2xl font-heading font-semibold text-foreground mb-2 truncate">
            {value}
          </div>
          {subtitle && (
            <div className="text-sm text-muted-foreground">
              {subtitle}
            </div>
          )}
        </div>
        
        <div className={`
          w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0
          ${colorClasses.bg} ${colorClasses.border} border
        `}>
          <Icon 
            name={icon} 
            size={24} 
            color={colorClasses.icon}
            strokeWidth={2}
          />
        </div>
      </div>

      {trend && (
        <div className="flex items-center mt-4 pt-4 border-t border-border">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
          />
          <span className={`
            ml-2 text-sm font-body font-medium
            ${trend === 'up' ? 'text-success' : 'text-error'}
          `}>
            {trendValue}
          </span>
          <span className="ml-1 text-sm text-muted-foreground truncate">
            vs last month
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricsCard;